import React from "react";
var __jsx = React.createElement;
import { Container, PictureIcon, Placeholder, Thumbnail, ThumbnailContainer } from './Thumbnails.style';

var Thumbnails = function Thumbnails(_ref) {
  var previewUrls = _ref.previewUrls,
      selectField = _ref.selectField;
  return __jsx(Container, null, previewUrls.map(function (previewUrl, index) {
    return previewUrl === undefined ? __jsx(Placeholder, {
      onClick: function onClick() {
        return selectField(index);
      },
      key: index
    }, __jsx(PictureIcon, null)) : __jsx(ThumbnailContainer, {
      onClick: function onClick() {
        return selectField(index);
      },
      key: index
    }, __jsx(Thumbnail, {
      src: previewUrl
    }));
  }));
};

export default Thumbnails;